import { shallowEqualKeys } from "core/utils"

export default function() {
  return {
    fn: { shallowEqualKeys }
  }
}



// WEBPACK FOOTER //
// ./src/core/plugins/util/index.js